/**
 * @generated SignedSource<<012449c3fe2fc929eda0ad92c928691a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion$data = {
  readonly id: string;
  readonly startAt: string;
  readonly taskExecution: {
    readonly checkValue: TaskSentiment | null;
    readonly id: string;
    readonly routine: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleRoutineListItemContent_Routine">;
    } | null;
    readonly routineOccasion: {
      readonly completedTaskExecutionCount: number | null;
      readonly id: string;
      readonly notDoneStatus: RoutineOccasionStatus;
      readonly sequenceNumber: number;
      readonly status: RoutineOccasionStatus;
      readonly store: {
        readonly myRole: Roles;
      } | null;
      readonly totalTaskExecutionCount: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircleInline_RoutineOccasion" | "TeamScheduleListItemScheduleRange_routineOccasion" | "TeamScheduleRoutineListItemContent_RoutineOccasion" | "TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion">;
    };
    readonly sectionId: string;
    readonly task: {
      readonly id: string;
    };
  };
  readonly " $fragmentType": "TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion";
};
export type TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion$key = {
  readonly " $data"?: TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskExecutionCheck",
      "kind": "LinkedField",
      "name": "taskExecution",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskCheck",
          "kind": "LinkedField",
          "name": "task",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineOccasion",
          "kind": "LinkedField",
          "name": "routineOccasion",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Store",
              "kind": "LinkedField",
              "name": "store",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "myRole",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sequenceNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notDoneStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "completedTaskExecutionCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalTaskExecutionCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "calculateNoTasks",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "calculateNotCompletedStarted",
                  "value": true
                }
              ],
              "kind": "ScalarField",
              "name": "status",
              "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RoutineOccasionStatusCircleInline_RoutineOccasion"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamScheduleRoutineListItemContent_RoutineOccasion"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamScheduleListItemScheduleRange_routineOccasion"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Routine",
          "kind": "LinkedField",
          "name": "routine",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamScheduleRoutineListItemContent_Routine"
            },
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamScheduleInlineRoutineOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "a70712abb5111ec218443a1a254cccd0";

export default node;
